import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyEditorNoOptOutMessage: FunctionComponent = () => {
  const EditorNoOptOutMessage = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "editor-no-opt-out-message" */ './EditorNoOptOutMessage'
      ),
    { namedImport: 'EditorNoOptOutMessage', preload: false },
  );

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <EditorNoOptOutMessage />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
